export default __webpack_public_path__ + "static/media/1027.feb6ab52.png";